import React from 'react'

import SvgClubTrendhim from '@Assets/SVG/ClubTrendhim'
import { NativeModal, NativeModalBody, NativeModalFooter, NativeModalHeader, useNativeModalActions } from '@Components/Modal/NativeModal/NativeModal'
import { ClubCreateAccount } from '@Domains/Club/Components/AuthenticationFlows/CreateAccount'
import { ClubCreateAccountOnlyPassword } from '@Domains/Club/Components/AuthenticationFlows/CreateAccountOnlyPassword'
import { ClubEmailDecision } from '@Domains/Club/Components/AuthenticationFlows/EmailDecision'
import { ClubForgotPassword } from '@Domains/Club/Components/AuthenticationFlows/ForgotPassword'
import { ClubResetPassword } from '@Domains/Club/Components/AuthenticationFlows/ResetPassword'
import { ClubSignIn } from '@Domains/Club/Components/AuthenticationFlows/SignIn'
import { ClubVerifyEmail } from '@Domains/Club/Components/AuthenticationFlows/VerifyEmail'
import { useClub } from '@Domains/Club/Hook'
import { useTranslation } from '@Globals/Translations'

import styles from './ClubModal.module.scss'

export const ClubModal = ({
  modalActionsRef,
}: {
  modalActionsRef: ReturnType<typeof useNativeModalActions>
}) => {
  const { tDanger } = useTranslation()
  const { modalState, setModalState } = useClub()

  return (
    <NativeModal
      actionRef={modalActionsRef}
      alignment="right"
      backdrop
      className={styles.clubModal}
      closeOnBackDrop
      closeOnEscape
      onClose={() => {
        setModalState('CLOSED')
      }}
    >
      <NativeModalHeader className={styles.floatButton} float />
      <NativeModalBody>
        <div className={styles.clubModalHeader}>
          <SvgClubTrendhim />
        </div>
        <div className={styles.clubAuthentication}>
          {modalState === 'CREATE_ACCOUNT' && <ClubCreateAccount />}
          {modalState === 'CREATE_ACCOUNT_ONLY_PASSWORD' && <ClubCreateAccountOnlyPassword />}
          {modalState === 'EMAIL_DECISION' && <ClubEmailDecision />}
          {modalState === 'FORGOT_PASSWORD' && <ClubForgotPassword />}
          {modalState === 'RESET_PASSWORD' && <ClubResetPassword />}
          {modalState === 'SIGN_IN' && <ClubSignIn />}
          {modalState === 'VERIFY_EMAIL' && <ClubVerifyEmail />}
        </div>
      </NativeModalBody>
      <NativeModalFooter className={styles.clubModalFooter}>
        <p className={styles.clubTerms} {...tDanger('common:TRENDHIMCLUB_MAIN_CTA_1_DYNAMIC', { percentage: '15' })} />
      </NativeModalFooter>
    </NativeModal>
  )
}

